import { ApiRoute } from "./api-route";
import { Profile } from "./profile";
import { SystemField } from "./system-field";

export class ApiRoutePermission extends SystemField{ 

    is_get?:number;
    is_post?:number;
    is_put?:number;
    is_delete?:number;
    profiles_id?:number;
    api_routes_id?:string;

    profile?:Profile;
    api_route?:ApiRoute;
}
